import styled from '@emotion/styled/macro';
import { Card, DataTable, ResponsibilityBadge, Tooltip, Variables } from '@enter/core';
import { ClaimActionButton } from 'components';

export const DataTableCard = styled(Card)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0;
    width: 100%;
`;

export const ClaimTable = styled(DataTable)`
    [role='columnheader'],
    [role='cell'] {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    [role='cell'] {
        overflow: hidden;
        padding: 0;
    }

    // TODO: replace with a global style for all data tables
    /* selectableRows pushes the selection column in at index 0, so the first cell holds the
       row checkbox. Its wrapper is shrink-to-fit, so the flex cell has to centre it to line
       up with the centred checkbox in the column header. */
    [role='cell']:first-of-type {
        justify-content: center;
    }

    [role='row'] {
        &:hover {
            background-color: ${Variables.Colors.n5};
        }
    }
`;

export const CellTooltip = styled(Tooltip)`
    width: 100%;
    padding: 8px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const HeaderCurrency = styled.span`
    display: inline-block;
    width: 100%;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Cell = styled.span`
    padding: 8px 16px;
`;

export const ClaimStatus = styled(ResponsibilityBadge)`
    margin: 0;
`;

export const PatientName = styled.span`
    font-weight: 500;
`;

export const PayerName = styled.span`
    font-weight: 400;
`;

export const CellCurrency = styled.span`
    flex-grow: 1;
    text-align: right;
    padding: 16px;
`;

export const Title = styled.div`
    padding: 2px;
`;

export const ActionButton = styled(ClaimActionButton)`
    margin-right: 16px;
`;

export const Hidden = styled.div`
    display: none;
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;